import React, { useState } from 'react'

function WhatDidTheySay() {

    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(!show)
    }

    return (
        <>
            <div className="flex flex-col px-5 mt-20 space-y-10">
                <div className="self-start text-5xl font-bold text-right whitespace-nowrap text-zinc-900">
                    شهادات قالوا عنا
                </div>
                <div className="w-full max-md:max-w-full">
                    <div className="grid grid-cols-2 gap-5 max-md:flex max-md:flex-col max-md:gap-0">
                        <div className="flex flex-col max-md:ml-0 max-md:w-full">
                            <div className="flex flex-col grow px-9 py-6 w-full bg-white rounded-3xl max-md:px-5 max-md:mt-6 max-md:max-w-full">
                                <div className="flex gap-4 justify-end font-semibold text-right max-md:flex-wrap">
                                    <img
                                        loading="lazy"
                                        srcSet="https://s3-alpha-sig.figma.com/img/8933/964f/a3549e7dff2565079c8e56c707fb80f9?Expires=1710720000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Jojl5psdA6XqyACP9ZnjfZTsr-oFLE1dnJCfY1DHZpBRffW8R7CP71KgI4i2W-gNgbU4zjmFvt~I8s5DkwvmMxbevlSdDkzT0AG03CeR9TW0PxA1HCVJe43a99cqfUGZ8LrXbil91WsOKUky45RphTIG4OKNflSrst2AX4sueXsjsUJy1xaCAi~ZmBqfFjOHBySvknSXAHtesg-YaYunhYBj7Kx-L5sSiS4r91-vyRJz3cLtsxZkKJ96lC7slouf~0odvnZbppzJ-OklTMbQt9qrDv0eLRBLZhPIca2cnZDmEVgV2YPCmqhfCZCf1k7E0dQpg9WNKDiVTKNoFnNaxw__"
                                        className="shrink-0 rounded-full aspect-square w-[70px]"
                                    />
                                    <div className="flex flex-col grow shrink-0 basis-0 w-fit max-md:max-w-full">
                                        <div className="text-2xl text-black max-md:max-w-full">
                                            محمود علي
                                        </div>
                                        <div className="mt-2 text-base text-zinc-400 max-md:max-w-full">
                                            مؤسس ومدير شركة ستاليون
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-4 text-base text-right text-zinc-900 max-md:max-w-full">
                                    من خلال تصفح الموقع، وجدت العديد من المشروعات والمؤسسات الخيرية
                                    المختلفة التي تقدم فرصًا للمساهمة بمختلف الطرق. كان من السهل
                                    جدًا التنقل في الموقع واختيار القضايا التي تعني الكثير لي.
                                </div>
                                <div className="flex gap-5 justify-between mt-4 w-full text-sm font-medium leading-5 whitespace-nowrap text-neutral-900 max-md:flex-wrap max-md:max-w-full">
                                    <div className="flex gap-2 justify-center self-end mt-8 rounded-2xl">
                                        <img
                                            loading="lazy"
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/ad91dfeac7f280cb7afacb3a47a2a991dfa96f3d657c50ccc2e47399118b1901?"
                                            className="shrink-0 w-5 aspect-square"
                                        />
                                        <div className="grow">السبت 23 سبتمبر 2023 م</div>
                                    </div>
                                    <img
                                        loading="lazy"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/cd17e8d72defc74448cda15c32d859c05fcfb62578109aa1fb90746cef629ecd?"
                                        className="shrink-0 aspect-square w-[52px]"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="max-w-7xl bg-white rounded-2xl dark:bg-gray-950 dark:text-white">
                    <form className={`w-full ${show ? 'p-4' : 'px-4 pt-4'}`}>
                        <div onClick={handleShow} className='flex flex-row justify-between'>
                            <h2 className="text-xl mb-4 font-bold text-gray-900 dark:text-gray-200">أترك تعلقياً</h2>
                            <svg x="0px" y="0px" width="20.686px" height="30.879px" viewBox="0 0 111.686 122.879" enableBackground="new 0 0 111.686 122.879"><g><path d="M83.896,5.08H27.789c-12.491,0-22.709,10.219-22.709,22.71v40.079c0,12.489,10.22,22.71,22.709,22.71h17.643 c-2.524,9.986-5.581,18.959-14.92,27.241c17.857-4.567,31.642-13.8,41.759-27.241h3.051c12.488,0,31.285-10.219,31.285-22.71V27.79 C106.605,15.299,96.387,5.08,83.896,5.08L83.896,5.08z M81.129,41.069c-4.551,0-8.24,3.691-8.24,8.242s3.689,8.242,8.24,8.242 c4.553,0,8.242-3.691,8.242-8.242S85.682,41.069,81.129,41.069L81.129,41.069z M30.556,41.069c-4.552,0-8.242,3.691-8.242,8.242 s3.69,8.242,8.242,8.242c4.551,0,8.242-3.691,8.242-8.242S35.107,41.069,30.556,41.069L30.556,41.069z M55.843,41.069 c-4.551,0-8.242,3.691-8.242,8.242s3.691,8.242,8.242,8.242c4.552,0,8.241-3.691,8.241-8.242S60.395,41.069,55.843,41.069 L55.843,41.069z M27.789,0h56.108h0.006v0.02c7.658,0.002,14.604,3.119,19.623,8.139l-0.01,0.01 c5.027,5.033,8.148,11.977,8.15,19.618h0.02v0.003h-0.02v40.079h0.02v0.004h-0.02c-0.004,8.17-5.68,15.289-13.24,20.261 c-7.041,4.629-15.932,7.504-23.104,7.505v0.021H75.32v-0.021h-0.576c-5.064,6.309-10.941,11.694-17.674,16.115 c-7.443,4.888-15.864,8.571-25.31,10.987l-0.004-0.016c-1.778,0.45-3.737-0.085-5.036-1.552c-1.852-2.093-1.656-5.292,0.437-7.144 c4.118-3.651,6.849-7.451,8.826-11.434c1.101-2.219,1.986-4.534,2.755-6.938h-10.95h-0.007v-0.021 c-7.656-0.002-14.602-3.119-19.622-8.139C3.138,82.478,0.021,75.53,0.02,67.871H0v-0.003h0.02V27.79H0v-0.007h0.02 C0.021,20.282,3.023,13.46,7.878,8.464C7.967,8.36,8.059,8.258,8.157,8.16c5.021-5.021,11.968-8.14,19.628-8.141V0H27.789L27.789,0 z" /></g>
                            </svg>
                        </div>
                        {show &&
                            <>
                                <p className="text-gray-600 mb-4">لن يتم نشر عنوان بريدك الإلكتروني. الحقول المطلوبة مشار إليها * </p>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                    <div className="mb-4 col-span-1 md:col-span-3">
                                        <textarea
                                            id="comment"
                                            name="comment"
                                            className="w-full px-3 py-2 dark:bg-gray-900 border rounded-lg dark:border-none border-gray-300 focus:outline-none border-solid focus:border-dashed resize-none"
                                            placeholder="* أكتب تعليقاً"
                                            rows="5"

                                            required
                                        ></textarea>
                                    </div>

                                    <div className="mb-4">
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            className="w-full px-3 py-2 dark:bg-gray-900 rounded-lg border dark:border-none border-gray-300 focus:outline-none border-solid focus:border-dashed"
                                            placeholder="*الأسم"
                                            required
                                        />
                                    </div>
                                    <div className="mb-4">
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            className="w-full px-3 py-2 dark:bg-gray-900 rounded-lg border dark:border-none border-gray-300 focus:outline-none border-solid focus:border-dashed"
                                            placeholder="*الإيميل"
                                            required
                                        />
                                    </div>
                                    <div className="mb-4">
                                        <input
                                            type="text"
                                            id="website"
                                            name="website"
                                            className="w-full px-3 py-2 dark:bg-gray-900 rounded-lg border dark:border-none border-gray-300 focus:outline-none border-solid focus:border-dashed"
                                            placeholder="*المسمى الوظيفي"
                                        />
                                    </div>
                                </div>
                                <div className="flex justify-end">
                                    <button
                                        type="submit"
                                        className="py-4 px-6 bg-blue-950 text-white rounded-sm hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800"
                                    >
                                        Post Comment →
                                    </button>
                                </div>
                            </>
                        }
                    </form>
                </div>
            </div>
        </>
    )
}

export default WhatDidTheySay